const netErrors = ["network error", "failed to fetch", "net::"];

export const isNetworkError = (error: unknown) => {
  const message = String(
    error instanceof Error ? error.message : error,
  ).toLowerCase();
  return netErrors.some(netErr => message.includes(netErr));
};
